import { OneEuroPoint } from 'shared/lib/tv-game/oneEuro.ts';

import { BODY_POSE_JOINTS, type BodyPose } from './bodyPoseFrame.ts';

/** Без кадров дольше этого поза считается потерянной (канал встал, телефон свёрнут). */
export const BODY_POSE_STALE_MS = 300;

/**
 * Последняя поза headless-телефона, сглаженная OneEuro по каждому суставу. Читается раз в кадр отрисовки, так что
 * пачка кадров после паузы канала просто перезаписывает друг друга; после паузы дольше `staleMs` фильтры
 * сбрасываются, чтобы точка не «доезжала» от старого места.
 */
export class BodyPoseStore {
  private readonly filters = new Map<string, OneEuroPoint>();

  private pose: BodyPose | null = null;

  private lastAtMs: number | null = null;

  constructor(private readonly staleMs = BODY_POSE_STALE_MS) {}

  push(raw: BodyPose, nowMs: number): void {
    if (this.lastAtMs === null || nowMs - this.lastAtMs > this.staleMs) this.filters.clear();
    const pose: BodyPose = {};
    BODY_POSE_JOINTS.forEach((joint) => {
      const point = raw[joint];
      if (!point) {
        // Сустав пропал из кадра: вернётся — без хвоста от прошлой позиции.
        this.filters.delete(joint);
        return;
      }
      let filter = this.filters.get(joint);
      if (!filter) {
        filter = new OneEuroPoint(1.5, 0.05);
        this.filters.set(joint, filter);
      }
      pose[joint] = filter.filter(point.x, point.y, nowMs / 1000);
    });
    this.pose = pose;
    this.lastAtMs = nowMs;
  }

  /** Поза на момент `nowMs`; `null` — кадров нет или они устарели. */
  current(nowMs: number): BodyPose | null {
    if (this.lastAtMs === null || nowMs - this.lastAtMs > this.staleMs) return null;
    return this.pose;
  }

  reset(): void {
    this.filters.clear();
    this.pose = null;
    this.lastAtMs = null;
  }
}
